var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4229 0.957962C16.4229 0.428894 16.0552 0 15.6017 0H0.821759C0.368273 0 0.000648499 0.428894 0.000648499 0.957962C0.000648499 1.48703 0.368273 1.91592 0.821759 1.91592H15.6017C16.0552 1.91592 16.4229 1.48703 16.4229 0.957962Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4229 6.73661C16.4229 6.20754 16.0552 5.77864 15.6017 5.77864H0.821759C0.368273 5.77864 0.000648499 6.20754 0.000648499 6.73661C0.000648499 7.26567 0.368273 7.69457 0.821759 7.69457H15.6017C16.0552 7.69457 16.4229 7.26567 16.4229 6.73661Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6017 11.5573C16.0552 11.5573 16.4229 11.9862 16.4229 12.5152C16.4229 13.0443 16.0552 13.4732 15.6017 13.4732H0.821759C0.368273 13.4732 0.000648499 13.0443 0.000648499 12.5152C0.000648499 11.9862 0.368273 11.5573 0.821759 11.5573H15.6017Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2539 3.03275L21.3398 1.91699L26.0017 6.7068L21.3399 11.4966L20.2539 10.3809L23.8298 6.70681L20.2539 3.03275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenu);
export default __webpack_public_path__ + "static/media/new_menu.e02cd1a171de9c160713a1c23daec57c.svg";
export { ForwardRef as ReactComponent };